module.exports = "<div class=inp-subtle> <span class=inp-subtle-span v-text=\"(fragment||'')+'.'\"></span> <textarea class=inp-big-focus :id=id type=text v-model=fragment @focus=\"show=1\" @blur=\"show=0\"></textarea> <span class=inp-actions v-if=show transition=opacity> <button type=button class=\"btn-reset fragment-type\" @click=literal>+</button> </span> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueText.vue
 ** module id = 150
 ** module chunks = 0
 **/